/* src/components/pages/Registrarasociado.jsx - Última MOdificación: 07-01-2026 */
/* ---------------------------------------------------------------------------- */

import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Button, TextField, Box, Modal, Typography, Divider, MenuItem, alpha,
  Checkbox, FormControl, FormControlLabel, Select, FormHelperText } from '@mui/material';

import api from '../../services/api.js'; // Api Interceptor en vez de Axios
  
import Link from '@mui/material/Link';
import { RiSave3Fill, RiReplyAllLine, RiVideoFill } from "react-icons/ri";

import { useFeedback } from '../../context/FeedbackContext'; // Mensajes breves


const Registrarasociado = ({ uniqueId, onClose, onSuccess }) => {
  const { showFeedback } = useFeedback(); // Mensaje breve

  const [open, setOpen] = useState(true); // modal empieza abierto cuando se montas
  const rutInputRef = useRef(null); // 👉 referencia al campo Rut

  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState(''); // Para mostrar el mensaje de error cliente ya existe //

  const [rutCli, setRutCli] = useState('');
  const [nombreEmp, setNombreEmp] = useState('');
  const [rutCliExists, setRutCliExists] = useState(false);
  const [rutEnrExists, setRutEnrExists] = useState(false);
  const [rutEnr, setRutEnr] = useState('');
  const [nombreEnr, setNombreEnr] = useState('');
  const [direccionEnr, setDireccionEnr] = useState('');
  const [comunaEnr, setComunaEnr] = useState('');
  const [ciudadEnr, setCiudadEnr] = useState('');
  const [telefonoEnr, setTelefonoEnr] = useState('');
  const [emailEnr, setEmailEnr] = useState('');
  const [clavesiiEnr, setClavesiiEnr] = useState('');
  const [claveunicaEnr, setClaveunicaEnr] = useState('');
  const [banco1Enr, setBanco1Enr] = useState('');
  const [banco2Enr, setBanco2Enr] = useState('');
  const [banco3Enr, setBanco3Enr] = useState('');
  const [ctacte1Enr, setCtacte1Enr] = useState('');
  const [ctacte2Enr, setCtacte2Enr] = useState('');
  const [ctacte3Enr, setCtacte3Enr] = useState('');

  const [bancos, setBancos] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);

  /* Control de términos y condiciones */
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [openTerms, setOpenTerms] = useState(false);

  /* Registrarse como proveedor */
  const [acceptedProvee, setAcceptedProvee] = useState(false);

  /* Estilo */
  const inputSx = {
    mt: 0.75,

    '& .MuiInputBase-root': {
      height: 38,
      fontSize: '0.84rem',
      borderRadius: 2,
      backdropFilter: 'blur(8px)',
    },

    '& .MuiOutlinedInput-input': {
      padding: '9px 12px',
    },

    '& .MuiInputLabel-root': {
      fontSize: '0.83rem',
      top: -7,
    },

    '& .MuiInputLabel-shrink': {
      top: 0,
    },

    '& .MuiFormHelperText-root': {
      marginLeft: 0,
      minHeight: 16,
      fontSize: '0.72rem',
      lineHeight: 1.1,
    },
  };

  /* Validación de formato de email */
  const validarEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  /* cargar bancos desde tabla bancos */
  const fetchBancos = useCallback(async () => {
    try {

      const response = await api.post('/registrarse/getbancos', {
        idBan: 0
      });

      if (response.data.success && response.data.rows) {
        setBancos(response.data.rows); // Asigna los datos al estado //
      } else {
        setBancos([]); // Si no hay datos, asegúrate de limpiar el estado //
      }

    } catch (error) {
      setBancos([]); // Si no hay datos, asegúrate de limpiar el estado //
    }
  }, []);

  /* carga los bancos */
  useEffect(() => {
    fetchBancos();
  }, [fetchBancos]);

  /* Validar bancos y ctasctes */
  const validateBankPair = (banco, cuenta, idx, newErrors) => {
    const bancoKey = `banco${idx}Enr`;
    const cuentaKey = `ctacte${idx}Enr`;

    newErrors[bancoKey] = '';
    newErrors[cuentaKey] = '';

    const cuentaValida = cuenta && cuenta.trim() !== '';
    const bancoValido = banco && banco.trim() !== '';

    if (bancoValido && !cuentaValida) {
      newErrors[cuentaKey] = `Debe ingresar la Ctacte ${idx}`;
    } else if (!bancoValido && cuentaValida) {
      newErrors[bancoKey] = `Debe seleccionar el Banco ${idx}`;
    }
  };

  /* Manejo de cambio y validaciones de input */
  const handleInputChange = async (e, fieldName) => {
    const { value } = e.target;
    let newErrors = { ...errors };

    switch (fieldName) {

      case 'rutCli': {

        setRutCli(value);
        setNombreEmp('');
        setRutCliExists(false);

        newErrors.rutCli = '';
        setMessage('');

        const cleanRut = normalizeRut(value);

        // vacío
        if (!cleanRut) {
          newErrors.rutCli = 'El Rut Empresa es obligatorio';
          setNombreEmp('');
          setRutCliExists(false);
          setErrors(newErrors);
          break;
        }

        // todavía escribiendo
        if (cleanRut.length < 10) {
          setErrors(newErrors);
          break;
        }

        // recién aquí validar módulo 11
        if (!validarRut(cleanRut)) {
          newErrors.rutCli = 'El Rut Empresa no es válido';
          setErrors(newErrors);
          break;
        }

        try {
          const exists = await checkRutCliExists(cleanRut);
          if (!exists) {
            newErrors.rutCli = 'El Rut Empresa no existe';
          }

        } catch (error) {
          console.error(error);
          newErrors.rutCli = 'Error al verificar el RUT Empresa';
        }

        break;
      }


      case 'rutEnr': {

        setRutEnr(value);

        newErrors.rutEnr = '';
        setRutEnrExists(false);
        setMessage('');

        const cleanRut = normalizeRut(value);

        // vacío
        if (!cleanRut) {
          newErrors.rutEnr = 'El Rut Enrolado es obligatorio';
          setRutEnrExists(false);
          setErrors(newErrors);
          break;
        }

        if (!validarRut(cleanRut)) {
          newErrors.rutEnr = 'El Rut del Enrolado ingresado no es válido';
          break;
        }

        if (cleanRut.length < 10) {
          setErrors(newErrors);
          setRutEnrExists(false);
          break;
        }

        try {

          const fixRutCli = normalizeRut(rutCli);
          const fixRutEnr = normalizeRut(value);

          const exists = await checkrutEnrExists(
            fixRutCli,
            fixRutEnr
          );

          if (exists) {
            newErrors.rutEnr = 'El Rut enrolado ya existe';
          }

        } catch {
          newErrors.rutEnr = 'Error al verificar el RUT';
        }

        break;
      }


      case 'nombreEnr':
        setNombreEnr(value);
        newErrors.nombreEnr = value.trim() === '' ? 'Debe ingresar el nombre' : '';
        break;

      case 'direccionEnr':
        setDireccionEnr(value);
        newErrors.direccionEnr = value.trim() === '' ? 'Debe ingresar la dirección' : '';
        break;

      case 'comunaEnr':
        setComunaEnr(value);
        newErrors.comunaEnr = value.trim() === '' ? 'Debe ingresar la comuna' : '';
        break;

      case 'ciudadEnr':
        setCiudadEnr(value);
        newErrors.ciudadEnr = value.trim() === '' ? 'Debe ingresar la ciudad' : '';
        break;

      case 'telefonoEnr':
        setTelefonoEnr(value);
        newErrors.telefonoEnr = value.trim() === '' ? 'Debe ingresar el teléfono' : '';
        break;

      case 'emailEnr':
        setEmailEnr(value);
        newErrors.emailEnr =
          value.trim() === '' || !validarEmail(value) ? 'El email ingresado no es válido' : '';
        break;

      case 'clavesiiEnr':
        setClavesiiEnr(value);
        newErrors.clavesiiEnr = value.trim() === '' ? 'Debe ingresar la clave del SII' : '';
        break;

      case 'claveunicaEnr':
        setClaveunicaEnr(value);
        newErrors.claveunicaEnr = '';
        break;

      // ---------- Bancos y Ctacte ----------
      case 'banco1Enr':
        setBanco1Enr(value);
        break;
      case 'ctacte1Enr':
        setCtacte1Enr(value);
        break;
      case 'banco2Enr':
        setBanco2Enr(value);
        break;
      case 'ctacte2Enr':
        setCtacte2Enr(value);
        break;
      case 'banco3Enr':
        setBanco3Enr(value);
        break;
      case 'ctacte3Enr':
        setCtacte3Enr(value);
        break;

      default:
        break;
    }

    // Validación bancos/cuentas con valores actualizados
    validateBankPair(
      fieldName === 'banco1Enr' ? value : banco1Enr,
      fieldName === 'ctacte1Enr' ? value : ctacte1Enr,
      1,
      newErrors
    );

    validateBankPair(
      fieldName === 'banco2Enr' ? value : banco2Enr,
      fieldName === 'ctacte2Enr' ? value : ctacte2Enr,
      2,
      newErrors
    );

    validateBankPair(
      fieldName === 'banco3Enr' ? value : banco3Enr,
      fieldName === 'ctacte3Enr' ? value : ctacte3Enr,
      3,
      newErrors
    );

    // Validación global
    const hasErrors = Object.values(newErrors).some(err => err && err !== '');
    const requiredFields = [
      fieldName === 'rutCli' ? value : rutCli,
      fieldName === 'rutEnr' ? value : rutEnr,
      fieldName === 'nombreEnr' ? value : nombreEnr,
      fieldName === 'direccionEnr' ? value : direccionEnr,
      fieldName === 'comunaEnr' ? value : comunaEnr,
      fieldName === 'ciudadEnr' ? value : ciudadEnr,
      telefonoEnr,
      emailEnr,
      fieldName === 'clavesiiEnr' ? value : clavesiiEnr
    ];
    const hasEmptyFields = requiredFields.some(field => !field || field.trim() === '');

    setErrors(newErrors);

    const rutCliValido = !!rutCliExists && !newErrors.rutCli;

    const rutEnrDisponible = !rutEnrExists && !newErrors.rutEnr;

    setIsFormValid(
      !hasErrors &&
      !hasEmptyFields &&
      rutCliValido &&
      rutEnrDisponible
    );
  }

  /* Validación del Rut (Módulo 11) */
  const validarRut = (rut) => {
    let valor = rut.replace(/\./g, '').replace('-', '');
    let cuerpo = valor.slice(0, -1);
    let dv = valor.slice(-1).toUpperCase();
    let suma = 0;
    let multiplo = 2;

    for (let i = 1; i <= cuerpo.length; i++) {
      let index = multiplo * valor.charAt(cuerpo.length - i);
      suma += index;
      multiplo = multiplo < 7 ? multiplo + 1 : 2;
    }

    let dvEsperado = 11 - (suma % 11);
    dvEsperado = dvEsperado === 11 ? '0' : dvEsperado === 10 ? 'K' : dvEsperado.toString();
    return dv === dvEsperado;
  };

  const normalizeRut = (rut = '') => {

    const clean = rut
      .replace(/\./g, '')
      .replace(/-/g, '')
      .trim()
      .toUpperCase();

    // evitar errores mientras escribe
    if (clean.length < 2) {
      return clean;
    }

    // separar cuerpo y dv
    const cuerpo = clean.slice(0, -1);
    const dv = clean.slice(-1);

    // cuerpo a largo 9
    const cuerpoPadded = cuerpo.padStart(9, '0');

    // total largo 10
    return `${cuerpoPadded}${dv}`;
  };

  /* Verificar si el rut del cliente existe en la bd */
  const checkRutCliExists = async (rut) => {
    try {
      const RutCli = normalizeRut(rut);

      const response = await api.post('/registrarse/checkrutcli', {
        RutCli
      });

      if (response.data.success && response.data.rows && response.data.rows.length > 0) {
        const nombre = response.data.rows[0].nombre_cli || '';
        setNombreEmp(nombre);
        setRutCliExists(true);
      } else {
        setNombreEmp('');
        setRutCliExists(false);
      }

      return response.data.success;

    } catch (error) {

      setNombreEmp('');
      setRutCliExists(false);

      return false;
    }
  };

  /* Verificar si el rut del cliente + asociado o enrolado ya existe en la bd */
  const checkrutEnrExists = async (fixrutCli, fixrutEnr) => {
    try {

      const response = await api.post('/registrarse/checkrutEnr', {
        RutCli: fixrutCli,
        RutEnr: fixrutEnr
      });

      // ESTA API NO DEVUELVE rows
      const exists = response?.data?.success === true;

      setRutEnrExists(exists);

      return exists;

    } catch (error) {

      setRutEnrExists(false);

      return false;
    }
  };


  /* Agregar enrolado */
  const handleSave = async () => {
    if (!acceptedTerms) {
      showFeedback(
        'Debe aceptar los Términos y Condiciones para continuar.',
        'warning'
      );
      return;
    }

    const validationErrors = {};
    setMessage(''); // Limpiar mensaje de error previo //
    if (!rutCli) {
      validationErrors.rutCli = 'El Rut Empresa es obligatorio';
    }
    if (!rutEnr) validationErrors.rutEnr = 'El Rut es obligatorio';
    if (!nombreEnr) validationErrors.nombreEnr = 'El Nombre es obligatorio';
    if (!direccionEnr) validationErrors.direccionEnr = 'La Dirección es obligatoria';
    if (!comunaEnr) validationErrors.comunaEnr = 'La Comuna es obligatoria';
    if (!ciudadEnr) validationErrors.ciudadEnr = 'La Ciudad es obligatoria';
    if (!telefonoEnr) validationErrors.telefonoEnr = 'El Teléfono es obligatorio';
    if (!emailEnr) validationErrors.emailEnr = 'El Email es obligatorio';

    if (banco1Enr) {
      if (!ctacte1Enr) {
        validationErrors.ctacte1Enr = 'Debe ingresar Ctacte 1';
      }
    }
    if (ctacte1Enr) {
      if (!banco1Enr) {
        validationErrors.banco1Enr = 'Debe seleccionar el Banco 1';
      }
    }

    if (banco2Enr) {
      if (!ctacte2Enr) {
        validationErrors.ctacte2Enr = 'Debe ingresar Ctacte 2';
      }
    }
    if (ctacte2Enr) {
      if (!banco2Enr) {
        validationErrors.banco2Enr = 'Debe seleccionar el Banco 2';
      }
    }

    if (banco3Enr) {
      if (!ctacte3Enr) {
        validationErrors.ctacte3Enr = 'Debe ingresar Ctacte 3';
      }
    }
    if (ctacte3Enr) {
      if (!banco3Enr) {
        validationErrors.banco3Enr = 'Debe seleccionar el Banco 3';
      }
    }

    /* Validación de formato de email */
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailEnr && !emailRegex.test(emailEnr)) {
      validationErrors.emailEnr = 'El Email no es válido';
    }
    
    if (!validarRut(rutCli)) {
      validationErrors.rutCli = 'El Rut de Empresa no es válido';
    }
    if (!validarRut(rutEnr)) {
      validationErrors.rutEnr = 'El Rut Enr no es válido';
    }

    const rutClienteExiste = await checkRutCliExists(rutCli);

    if (!rutClienteExiste) {
      validationErrors.rutCli = 'El Rut de Empresa no existe';
    }

    const fixrutCli = normalizeRut(rutCli);
    const fixrutEnr = normalizeRut(rutEnr);

    const rutEnroladoExiste = await checkrutEnrExists(
      fixrutCli,
      fixrutEnr
    );

    if (rutEnroladoExiste) {
      validationErrors.rutEnr = 'El Rut enrolado ya existe';
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const uppernombreEnr = nombreEnr.toUpperCase();
    const upperdireccionEnr = direccionEnr.toUpperCase();
    const uppercomunaEnr = comunaEnr.toUpperCase();
    const upperciudadEnr = ciudadEnr.toUpperCase();
    const loweremailEnr = emailEnr.toLowerCase();

    /* agregar registro */
    try {

      const fixrutCli = normalizeRut(rutCli);
      const fixrutEnr = normalizeRut(rutEnr);

      await api.post('registrarse/addenrolado', {
        rut_cli: fixrutCli,   // rut del cliente
        rut_enr: fixrutEnr,   // rut del asociado o enrolado
        nombre_enr: uppernombreEnr,
        direccion_enr: upperdireccionEnr,
        comuna_enr: uppercomunaEnr,
        ciudad_enr: upperciudadEnr,
        telefono_enr: telefonoEnr,
        email_enr: loweremailEnr,
        clavesii_enr: clavesiiEnr,
        claveunica_enr: claveunicaEnr,
        proveedor_enr: acceptedProvee,
        banco1_enr: banco1Enr,
        ctacte1_enr: ctacte1Enr,
        banco2_enr: banco2Enr,
        ctacte2_enr: ctacte2Enr,
        banco3_enr: banco3Enr,
        ctacte3_enr: ctacte3Enr,
        uniqueId
      });

      onSuccess(); // 👈 avisa éxito al padre Login.jsx

    } catch (error) {
      showFeedback(
        'Hubo un problema al procesar la solicitud, intente mas tarde.',
        'error'
      );
    }
  };

  /* Abrir Modal para Crear Enrolado */
  const handleAdd = () => {
    setRutCli('');
    setRutEnr('');
    setNombreEnr('');
    setDireccionEnr('');
    setComunaEnr('');
    setCiudadEnr('');
    setTelefonoEnr('');
    setEmailEnr('');
    setClavesiiEnr('');
    setClaveunicaEnr('');
    setBanco1Enr('');
    setCtacte1Enr('');
    setBanco2Enr('');
    setCtacte2Enr('');
    setBanco3Enr('');
    setCtacte3Enr('');
    setMessage('');

    /* Limpiar el error de todos los input */
    setErrors(prevErrors => ({
      ...prevErrors,
      rutCli: '',
      nombreEnr: '',
      direccionEnr: '',
      comunaEnr: '',
      ciudadEnr: '',
      telefonoEnr: '',
      emailEnr: '',
      banco1Enr: '',
      ctacte1Enr: '',
      banco2Enr: '',
      ctacte2Enr: '',
      banco3Enr: '',
      ctacte3Enr: ''
    }));
  };

  /* estado para cerrar el modal */
  const handleCloseModal = () => {
    setOpen(false);
    if (onClose) onClose(); // avisa al padre Login.jsx que se cerró el modal
  };

  /* 👉 al abrir modal, enfocar en RUT */
  useEffect(() => {
    if (open && rutInputRef.current) {
      handleAdd();
      rutInputRef.current.focus();
    }
  }, [open]);



  /* render de los datos */
  return (
    <div>

      {/* =====================================================
          MODAL REGISTRO ENROLADOS
      ===================================================== */}

      <Modal
        open={open}
        disableEnforceFocus={false}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            handleCloseModal();
          }
        }}
      >

        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',

            width: 760,
            maxWidth: '95vw',
            maxHeight: '92vh',

            bgcolor: 'background.paper',

            border: '1px solid',
            borderColor: 'divider',

            borderRadius: 3,

            backdropFilter: 'blur(12px)',

            boxShadow:
              '0 20px 80px rgba(0,0,0,0.45)',

            p: 2.2,

            overflowY: 'auto',
          }}
        >

          {/* HEADER */}

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 1,
            }}
          >

            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 800,
                letterSpacing: 0.4,
                color: (theme) => theme.palette.warning.main,
              }}
            >
              👥 Incorporación Cliente / Proveedor
            </Typography>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.6,
                opacity: 0.85,
              }}
            >
              <RiVideoFill size={18} color="#F5A53D" />

              <Typography
                variant="caption"
                sx={{
                  fontWeight: 700,
                  letterSpacing: 0.4,
                  color: 'text.secondary',
                }}
              >
                OverWatch
              </Typography>
            </Box>
          </Box>

          <Divider sx={{ my: 1.25, opacity: 0.5 }} />

          {/* ERROR */}

          {message && (
            <Box
              sx={{
                mb: 1.5,
                px: 1.5,
                py: 1,
                borderRadius: 2,

                backgroundColor: (theme) =>
                  alpha(theme.palette.error.main, 0.08),

                border: (theme) =>
                  `1px solid ${alpha(theme.palette.error.main, 0.25)}`,
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  color: 'error.main',
                  fontWeight: 700,
                  display: 'block',
                  textAlign: 'center',
                }}
              >
                {message}
              </Typography>
            </Box>
          )}

          {/* =========================================
              RUT EMPRESA + RUT ENROLADO
          ========================================= */}

          <Box
            sx={{
              display: 'flex',
              gap: 1.5,
              alignItems: 'flex-start',
            }}
          >

            {/* RUT EMPRESA */}

            <TextField
              label="Rut Empresa"
              value={rutCli}
              onChange={(e) => handleInputChange(e, 'rutCli')}
              onBlur={(e) => handleInputChange(e, 'rutCli')}
              inputRef={rutInputRef}
              error={Boolean(errors.rutCli)}
              helperText={errors.rutCli}
              autoComplete="off"
              autoFocus
              slotProps={{
                input: {
                  htmlInput: {
                    maxLength: 12,
                  },
                },
              }}
              sx={{
                ...inputSx,
                width: 170,
                flexShrink: 0,
              }}
            />

            {/* RUT ENROLADO */}

            <TextField
              label="Rut Enrolado"
              placeholder="Ingrese el RUT"
              value={rutEnr}
              onChange={(e) => handleInputChange(e, 'rutEnr')}
              onBlur={(e) => handleInputChange(e, 'rutEnr')}
              error={Boolean(errors.rutEnr)}
              helperText={errors.rutEnr}
              autoComplete="off"
              slotProps={{
                input: {
                  htmlInput: {
                    maxLength: 12,
                  },
                },
              }}
              sx={{
                ...inputSx,
                width: 170,
                flexShrink: 0,
              }}
            />

            {/* EMPRESA */}

            <TextField
              label="Empresa"
              value={nombreEmp}
              disabled
              fullWidth
              sx={inputSx}
            />
          </Box>

          {/* RAZON SOCIAL */}

          <TextField
            label="Razón Social"
            placeholder="Ingrese la Razón Social"
            value={nombreEnr}
            onChange={(e) => handleInputChange(e, 'nombreEnr')}
            fullWidth
            error={Boolean(errors.nombreEnr)}
            helperText={errors.nombreEnr}
            autoComplete="off"
            sx={inputSx}
          />

          {/* DIRECCION */}

          <TextField
            label="Dirección"
            placeholder="Ingrese la Dirección"
            value={direccionEnr}
            onChange={(e) => handleInputChange(e, 'direccionEnr')}
            fullWidth
            error={Boolean(errors.direccionEnr)}
            helperText={errors.direccionEnr}
            autoComplete="off"
            sx={inputSx}
          />

          {/* COMUNA + CIUDAD */}

          <Box
            sx={{
              display: 'flex',
              gap: 1.5,
              alignItems: 'flex-start',
            }}
          >

            <Box sx={{ flex: 1 }}>
              <TextField
                label="Comuna"
                placeholder="Ingrese la comuna"
                value={comunaEnr}
                onChange={(e) => handleInputChange(e, 'comunaEnr')}
                fullWidth
                error={Boolean(errors.comunaEnr)}
                helperText={errors.comunaEnr}
                autoComplete="off"
                sx={inputSx}
              />
            </Box>

            <Box sx={{ flex: 1 }}>
              <TextField
                label="Ciudad"
                placeholder="Ingrese la ciudad"
                value={ciudadEnr}
                onChange={(e) => handleInputChange(e, 'ciudadEnr')}
                fullWidth
                error={Boolean(errors.ciudadEnr)}
                helperText={errors.ciudadEnr}
                autoComplete="off"
                sx={inputSx}
              />
            </Box>
          </Box>

          {/* TELEFONO + EMAIL */}

          <Box
            sx={{
              display: 'flex',
              gap: 1.5,
              alignItems: 'flex-start',
            }}
          >

            <Box sx={{ width: 180 }}>
              <TextField
                label="Teléfono"
                placeholder="Teléfono"
                value={telefonoEnr}
                onChange={(e) => handleInputChange(e, 'telefonoEnr')}
                fullWidth
                error={Boolean(errors.telefonoEnr)}
                helperText={errors.telefonoEnr}
                autoComplete="off"
                sx={inputSx}
              />
            </Box>

            <Box sx={{ flex: 1 }}>
              <TextField
                label="Email"
                placeholder="Ingrese el Email"
                value={emailEnr}
                onChange={(e) => handleInputChange(e, 'emailEnr')}
                fullWidth
                error={Boolean(errors.emailEnr)}
                helperText={errors.emailEnr}
                autoComplete="off"
                sx={inputSx}
              />
            </Box>
          </Box>

          <Divider sx={{ my: 1.4, opacity: 0.5 }} />

          {/* CLAVES */}

          <Box
            sx={{
              display: 'flex',
              gap: 1.5,
              alignItems: 'flex-start',
            }}
          >

            <Box sx={{ flex: 1 }}>
              <TextField
                label="Clave SII"
                placeholder="Ingrese la Clave SII"
                value={clavesiiEnr}
                onChange={(e) => handleInputChange(e, 'clavesiiEnr')}
                fullWidth
                error={Boolean(errors.clavesiiEnr)}
                helperText={errors.clavesiiEnr}
                autoComplete="off"
                sx={inputSx}
              />
            </Box>

            <Box sx={{ flex: 1 }}>
              <TextField
                label="Clave Única"
                placeholder="Ingrese la Clave Única"
                value={claveunicaEnr}
                onChange={(e) => handleInputChange(e, 'claveunicaEnr')}
                fullWidth
                error={Boolean(errors.claveunicaEnr)}
                helperText={errors.claveunicaEnr}
                autoComplete="off"
                sx={inputSx}
              />
            </Box>
          </Box>

          {/* BANCOS */}

          <Box
            sx={{
              display: 'flex',
              gap: 1.5,
              alignItems: 'flex-start',
            }}
          >

            {[1, 2, 3].map((num) => {

              const bancoValue =
                num === 1 ? banco1Enr :
                num === 2 ? banco2Enr :
                banco3Enr;

              const bancoError =
                num === 1 ? errors.banco1Enr :
                num === 2 ? errors.banco2Enr :
                errors.banco3Enr;

              return (
                <Box key={num} sx={{ flex: 1 }}>

                  <FormControl
                    fullWidth
                    error={Boolean(bancoError)}
                    sx={inputSx}
                  >

                    <Select
                      value={bancoValue}
                      displayEmpty
                      onChange={(e) =>
                        handleInputChange(
                          e,
                          `banco${num}Enr`
                        )
                      }
                      sx={{
                        height: 38,
                        fontSize: '0.84rem',
                        borderRadius: 2,
                        color: bancoValue
                          ? 'white'
                          : 'text.secondary',
                      }}
                    >

                      <MenuItem value="">
                        <Typography
                          variant="caption"
                          sx={{
                            color: (theme) =>
                              theme.palette.warning.light,
                          }}
                        >
                          ✨ Banco {num}
                        </Typography>
                      </MenuItem>

                      {bancos.map((banco) => (
                        <MenuItem
                          key={banco.id}
                          value={String(banco.id)}
                        >
                          {banco.nomban}
                        </MenuItem>
                      ))}

                    </Select>

                    {bancoError && (
                      <FormHelperText>
                        {bancoError}
                      </FormHelperText>
                    )}

                  </FormControl>

                </Box>
              );
            })}
          </Box>

          {/* CUENTAS */}

          <Box
            sx={{
              display: 'flex',
              gap: 1.5,
              alignItems: 'flex-start',
            }}
          >

            {[1, 2, 3].map((num) => {

              const value =
                num === 1 ? ctacte1Enr :
                num === 2 ? ctacte2Enr :
                ctacte3Enr;

              const error =
                num === 1 ? errors.ctacte1Enr :
                num === 2 ? errors.ctacte2Enr :
                errors.ctacte3Enr;

              return (
                <Box key={num} sx={{ flex: 1 }}>

                  <TextField
                    label={`Ctacte ${num}`}
                    value={value}
                    onChange={(e) =>
                      handleInputChange(
                        e,
                        `ctacte${num}Enr`
                      )
                    }
                    fullWidth
                    error={Boolean(error)}
                    helperText={error}
                    autoComplete="off"
                    sx={inputSx}
                  />

                </Box>
              );
            })}
          </Box>

          {/* CHECKS + BOTONES */}

          <Box
            sx={{
              mt: 1,

              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',

              gap: 1,
            }}
          >

            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 1.5,
              }}
            >

              {/* PROVEEDOR */}

              <FormControlLabel
                sx={{
                  margin: 0,

                  '.MuiCheckbox-root': {
                    padding: '4px',
                  },
                }}
                control={
                  <Checkbox
                    checked={acceptedProvee}
                    onChange={(e) =>
                      setAcceptedProvee(
                        e.target.checked
                      )
                    }
                    size="small"
                    color="warning"
                  />
                }
                label={
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 600,
                      lineHeight: 1.4,
                      color: 'text.secondary',
                    }}
                  >
                    Registrarme como proveedor
                  </Typography>
                }
              />

              {/* TERMINOS */}

              <FormControlLabel
                sx={{
                  margin: 0,

                  '.MuiCheckbox-root': {
                    padding: '4px',
                  },
                }}
                control={
                  <Checkbox
                    checked={acceptedTerms}
                    onChange={(e) =>
                      setAcceptedTerms(
                        e.target.checked
                      )
                    }
                    size="small"
                    color="warning"
                  />
                }
                label={
                  <Typography
                    variant="caption"
                    sx={{
                      lineHeight: 1.4,
                      color: 'text.secondary',
                    }}
                  >
                    Acepto los{' '}

                    <Link
                      component="button"
                      underline="hover"
                      sx={{
                        fontWeight: 700,
                        color: '#60A5FA',
                        cursor: 'pointer',
                        fontSize: '0.78rem',

                        transition: 'all 0.2s ease',

                        '&:hover': {
                          color: '#93C5FD',
                        },
                      }}
                      onClick={() => setOpenTerms(true)}
                    >
                      Términos y Condiciones
                    </Link>
                  </Typography>
                }
              />
            </Box>

            {/* BOTONES */}

            <Box
              sx={{
                display: 'flex',
                gap: 1,
              }}
            >

              <Button
                variant="contained"
                color="warning"
                disabled={
                  !acceptedTerms ||
                  !isFormValid
                }
                startIcon={<RiSave3Fill />}
                onClick={handleSave}
                sx={{
                  textTransform: 'none',
                  fontWeight: 700,
                  borderRadius: 2,
                  px: 2,
                  py: 0.7,
                  fontSize: '0.82rem',
                }}
              >
                Grabar
              </Button>

              <Button
                variant="outlined"
                color="inherit"
                startIcon={<RiReplyAllLine />}
                onClick={handleCloseModal}
                sx={{
                  textTransform: 'none',
                  borderRadius: 2,
                  px: 2,
                  py: 0.7,
                  fontSize: '0.82rem',
                }}
              >
                Cancelar
              </Button>

            </Box>
          </Box>
        </Box>
      </Modal>

      {/* =====================================================
          MODAL TERMINOS
      ===================================================== */}

      <Modal
        open={openTerms}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            setOpenTerms(false);
          }
        }}
      >

        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',

            width: 720,
            maxWidth: '95vw',
            maxHeight: '92vh',

            bgcolor: 'rgba(18,18,20,0.94)',

            border: '1px solid rgba(255,255,255,0.08)',

            borderRadius: 4,

            backdropFilter: 'blur(20px)',

            boxShadow:
              '0 30px 120px rgba(0,0,0,0.65)',

            p: 3,

            overflowY: 'auto',
          }}
        >

          {/* =====================================================
              HEADER
          ===================================================== */}

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 1,
            }}
          >

            <Box>

              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 800,
                  letterSpacing: 0.4,
                  color: '#F5A53D',
                }}
              >
                Términos y Condiciones
              </Typography>

              <Typography
                variant="caption"
                sx={{
                  color: 'rgba(255,255,255,0.48)',
                  fontSize: '0.74rem',
                  letterSpacing: 0.2,
                }}
              >
                Plataforma OverWatch
              </Typography>

            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.7,
                opacity: 0.6,
              }}
            >
              <RiVideoFill size={18} color="#F5A53D" />

              <Typography
                variant="caption"
                sx={{
                  fontWeight: 700,
                  letterSpacing: 0.4,
                  color: 'rgba(255,255,255,0.7)',
                }}
              >
                OverWatch
              </Typography>
            </Box>
          </Box>

          <Divider
            sx={{
              my: 1.6,
              borderColor: 'rgba(255,255,255,0.08)',
            }}
          />

          {/* =====================================================
              INTRO
          ===================================================== */}

          <Typography
            variant="body2"
            sx={{
              mb: 2.5,

              color: 'rgba(255,255,255,0.62)',

              lineHeight: 1.8,

              fontSize: '0.82rem',
            }}
          >
            Antes de utilizar la plataforma, le recomendamos leer
            atentamente las siguientes condiciones relacionadas
            con el uso, seguridad y tratamiento de la información.
          </Typography>

          {/* =====================================================
              BLOQUES
          ===================================================== */}

          {[
            {
              title: 'Confidencialidad y Seguridad',
              text:
                'La información entregada será tratada de forma confidencial y protegida mediante medidas de seguridad adecuadas.',
            },
            {
              title: 'Protección de Datos Personales',
              text:
                'Los datos serán utilizados únicamente para fines relacionados con el funcionamiento de la plataforma.',
            },
            {
              title: 'Buen Uso de la Aplicación',
              text:
                'El usuario se compromete a utilizar la plataforma de manera responsable y conforme a la normativa vigente.',
            },
            {
              title: 'Responsabilidad del Usuario',
              text:
                'Cada usuario es responsable de la veracidad de los datos proporcionados y del uso de sus credenciales.',
            },
            {
              title: 'Responsabilidad del Propietario',
              text:
                'El propietario velará por la seguridad y disponibilidad razonable del servicio.',
            },
            {
              title: 'Propiedad Intelectual',
              text:
                'La plataforma y sus contenidos están protegidos por las leyes de propiedad intelectual.',
            },
            {
              title: 'Modificaciones',
              text:
                'Los términos podrán actualizarse periódicamente notificando oportunamente a los usuarios.',
            },
          ].map((item) => (
            <Box
              key={item.title}
              sx={{
                mb: 1.6,

                p: 1.5,

                borderRadius: 2.5,

                background:
                  'rgba(255,255,255,0.025)',

                border:
                  '1px solid rgba(255,255,255,0.05)',

                transition: 'all 0.2s ease',

                '&:hover': {
                  background:
                    'rgba(255,255,255,0.04)',

                  border:
                    '1px solid rgba(255,255,255,0.08)',
                },
              }}
            >

              <Typography
                variant="caption"
                sx={{
                  display: 'block',

                  fontWeight: 700,

                  fontSize: '0.82rem',

                  mb: 0.6,

                  color: 'rgba(255,255,255,0.92)',

                  letterSpacing: 0.2,
                }}
              >
                {item.title}
              </Typography>

              <Typography
                variant="caption"
                sx={{
                  display: 'block',

                  fontSize: '0.78rem',

                  lineHeight: 1.8,

                  color: 'rgba(255,255,255,0.62)',
                }}
              >
                {item.text}
              </Typography>

            </Box>
          ))}

          <Divider
            sx={{
              my: 1.8,
              borderColor: 'rgba(255,255,255,0.08)',
            }}
          />

          {/* =====================================================
              FOOTER
          ===================================================== */}

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 2,
            }}
          >

            <Typography
              variant="caption"
              sx={{
                color: 'rgba(255,255,255,0.42)',
                fontSize: '0.72rem',
              }}
            >
              Última actualización · Mayo 2026
            </Typography>

            <Button
              variant="outlined"
              color="warning"
              onClick={() => setOpenTerms(false)}
              sx={{
                textTransform: 'none',

                borderRadius: 2.5,

                px: 2.5,
                py: 0.7,

                fontSize: '0.82rem',

                fontWeight: 700,

                borderWidth: 1.5,

                '&:hover': {
                  borderWidth: 1.5,
                },
              }}
            >
              Cerrar
            </Button>

          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default Registrarasociado;
